import React from 'react'
import { Base, LazyLoadBlock } from '../../../components'
import { TextBlock } from '../../../shared/components/v2/TextBlock/TextBlock'
import { WebPageStructuredData, PAGES } from '../../../utils'
import { careersAtNorthOneProps, careersBenefitsProps } from '../../../data/pages/about/careers.data'

const Careers = (): JSX.Element => {
  const CAREERS = PAGES.ABOUT.CAREERS
  return (
    <Base
      headKey={CAREERS.HEAD_KEY}
      title={CAREERS.TITLE}
      metaDescription={CAREERS.DESCRIPTION}
      breadcrumbs={CAREERS.BREADCRUMBS}
    >
      <WebPageStructuredData
        name={CAREERS.TITLE}
        description={CAREERS.DESCRIPTION}
        path={CAREERS.PATH}
        breadcrumbs={CAREERS.BREADCRUMBS}
      />

      <TextBlock {...careersAtNorthOneProps} />

      <LazyLoadBlock>
        <TextBlock {...careersBenefitsProps} />
      </LazyLoadBlock>
    </Base>
  )
}

export default Careers
